import { FormControl, FormLabel, Radio, RadioGroup, Select, Stack } from '@chakra-ui/react'
import type { PersonAdditionalData, WizardPropertyAdditionalData } from 'BrokerTsLib/src/dtos'
import { Selection, SelectionType } from 'BrokerTsLib/src/enums'
import { useFormContext } from 'BrokerTsLib/src/rhf'
import { useEffect } from 'react'

import RuianAddressSelector from '@/components/RuianAddressSelector'
import { FormBody } from '@/containers/forms/FormBody'
import { FormRow } from '@/containers/forms/FormRow'
import ICOOptions from '@/containers/forms/person/ICOOptions'
import InsureeName from '@/containers/forms/person/InsureeName'
import PersonType from '@/containers/forms/person/PersonType'
import { useInsuranceParams } from '@/context/InsuranceParamsProvider'
import { useSelections } from '@/hooks'
import { useNameof } from '@/hooks/useNameof'
import { isIn } from 'BrokerTsLib/src/Utils/comparisonUtils'

export const AdditionalContactInfoForm = () => {
  const { isDisabled } = useInsuranceParams()

  const { watch, register, getValues, setValue } = useFormContext<WizardPropertyAdditionalData>()

  const nameof = useNameof<WizardPropertyAdditionalData>()
  const personPrefix = nameof(x => x.policyHolder.contact)
  const pnameof = useNameof<PersonAdditionalData>(personPrefix)

  const { data: dataTitles } = useSelections(SelectionType.TitleBefore)

  const contactSameAs = watch('policyHolder.contactSameAs')
  const pType = watch('policyHolder.contact.type')

  const sameAsOptions = [
    { label: 'Stejná s pojistníkem', value: Selection.PersonSameAsPolicyHolder },
    { label: 'Jiná', value: null },
  ]

  // nastavení default typu osoby pri prekliknuti
  useEffect(() => {
    if (!contactSameAs && !pType)
      setValue('policyHolder.contact.type', Selection.Person)
  }, [contactSameAs])

  return (
    <FormBody>
      <FormControl>
        <RadioGroup
          {...register('policyHolder.contactSameAs', { setValueAs: (value) => value == 0 ? null : parseInt(value) })}
          value={contactSameAs?.toString() ?? '0'}
          name="policyHolder.contactSameAs"
          isDisabled={isDisabled}
          onChange={(value) => setValue('policyHolder.contactSameAs', parseInt(value))}
        >
          <Stack direction="row" spacing={16}>
            {sameAsOptions?.map((item) => (
              <Radio key={item.value ?? -1} value={item.value?.toString() ?? '0'}>
                {item.label}
              </Radio>
            ))}
          </Stack>
        </RadioGroup>
      </FormControl>

      {!contactSameAs &&
        <>
          <PersonType personPrefix={personPrefix} disabled={isDisabled} />

          {isIn(pType, Selection.Company, Selection.SelfEmployed) &&
            <ICOOptions personPrefix={personPrefix} disabled={isDisabled} hideIc />
          }

          {isIn(pType, Selection.Person, Selection.SelfEmployed) &&
            <FormRow itemsCount={3}>
              <FormControl>
                <FormLabel>Titul před jménem</FormLabel>

                {(dataTitles?.data.length ?? 0) > 0 &&
                  <Select
                    {...register('policyHolder.contact.titleBefore')}
                    isDisabled={isDisabled}
                    defaultValue={getValues('policyHolder.contact.titleBefore') ?? ''}
                  >
                    <option value=''>Vyberte</option>
                    {dataTitles?.data.map((item) => (
                      <option value={item.value?.toString()} key={item.id}>{item.value}</option>
                    ))}
                  </Select>
                }
              </FormControl>

              <InsureeName personPrefix={personPrefix} disabled={isDisabled} />
            </FormRow>
          }

          {/* <InsureeAddress
            addressPrefix={pnameof(x => x.address)}
            isDisabled={isDisabled}
            isDisabledStreet={isDisabled}
            street={true}
          /> */}

          <RuianAddressSelector
            addressPath={pnameof((x) => x.address)}
            isDisabled={isDisabled}
            showOnlyLotNumber={false}
          />
        </>
      }

    </FormBody>
  )
}